var M = Object.prototype.hasOwnProperty;
function N(e, t) {
  var n, o;
  if (e === t) return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date) return e.getTime() === t.getTime();
    if (n === RegExp) return e.toString() === t.toString();
    if (n === Array) {
      if ((o = e.length) === t.length)
        for (; o-- && N(e[o], t[o]); ) ;
      return o === -1;
    }
    if (!n || typeof e == "object") {
      o = 0;
      for (n in e)
        if (M.call(e, n) && ++o && !M.call(t, n) || !(n in t) || !N(e[n], t[n])) return !1;
      return Object.keys(t).length === o;
    }
  }
  return e !== e && t !== t;
}
function _() {
}
function F(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
const z = [];
function P(e, t = _) {
  let n;
  const o = /* @__PURE__ */ new Set();
  function s(b) {
    if (F(e, b) && (e = b, n)) {
      const E = !z.length;
      for (const h of o)
        h[1](), z.push(h, e);
      if (E) {
        for (let h = 0; h < z.length; h += 2)
          z[h][0](z[h + 1]);
        z.length = 0;
      }
    }
  }
  function p(b) {
    s(b(e));
  }
  function A(b, E = _) {
    const h = [b, E];
    return o.add(h), o.size === 1 && (n = t(s, p) || _), b(e), () => {
      o.delete(h), o.size === 0 && n && (n(), n = null);
    };
  }
  return { set: s, update: p, subscribe: A };
}
const Oe = (e) => {
  const { subscribe: t, set: n } = P();
  let o;
  return t((s) => o = s), e.observe(({ changes: s }) => {
    if (o) {
      (s.deleted || []).some((b) => b.id === o) && n(void 0);
      const A = (s.updated || []).find(({ oldValue: b }) => b.id === o);
      A && n(A.newValue.id);
    }
  }), {
    get current() {
      return o;
    },
    subscribe: t,
    set: n
  };
};
var K = /* @__PURE__ */ ((e) => (e.EDIT = "EDIT", e.SELECT = "SELECT", e.NONE = "NONE", e))(K || {});
const V = { selected: [] }, De = (e, t, n) => {
  const { subscribe: o, set: s } = P(V);
  let p = t, A = V;
  o((m) => A = m);
  const b = () => {
    N(A, V) || s(V);
  }, E = () => {
    var m;
    return ((m = A.selected) == null ? void 0 : m.length) === 0;
  }, h = (m) => {
    if (E())
      return !1;
    const C = typeof m == "string" ? m : m.id;
    return A.selected.some((T) => T.id === C);
  }, S = (m, C) => {
    let T;
    if (Array.isArray(m)) {
      if (T = m.map((d) => e.getAnnotation(d)).filter(Boolean), T.length < m.length) {
        console.warn("Invalid selection: " + m.filter((d) => !T.some((g) => g.id === d)));
        return;
      }
    } else {
      const d = e.getAnnotation(m);
      if (!d) {
        console.warn("Invalid selection: " + m);
        return;
      }
      T = [d];
    }
    const a = T.reduce((d, g) => {
      const v = W(g, p, n);
      return v === "EDIT" ? [...d, { id: g.id, editable: !0 }] : v === "SELECT" ? [...d, { id: g.id }] : d;
    }, []);
    s({ selected: a, event: C });
  }, l = (m, C) => {
    const T = Array.isArray(m) ? m : [m], a = T.map((d) => e.getAnnotation(d)).filter((d) => !!d);
    s({
      selected: a.map((d) => {
        const g = C === void 0 ? W(d, p, n) === "EDIT" : C;
        return { id: d.id, editable: g };
      })
    }), a.length !== T.length && console.warn("Invalid selection", m);
  }, w = (m) => {
    if (E())
      return !1;
    const { selected: C } = A;
    C.some(({ id: a }) => m.includes(a)) && s({ selected: C.filter(({ id: a }) => !m.includes(a)) });
  }, D = (m) => {
    p = m, l(A.selected.map(({ id: C }) => C));
  };
  return e.observe(
    ({ changes: m }) => w((m.deleted || []).map((C) => C.id))
  ), {
    get event() {
      return A ? A.event : null;
    },
    get selected() {
      return A ? [...A.selected] : null;
    },
    get userSelectAction() {
      return p;
    },
    clear: b,
    isEmpty: E,
    isSelected: h,
    setSelected: l,
    setUserSelectAction: D,
    subscribe: o,
    userSelect: S
  };
}, W = (e, t, n) => {
  const o = n ? n.serialize(e) : e;
  return typeof t == "function" ? t(o) : t || "EDIT";
}, R = [];
for (let e = 0; e < 256; ++e)
  R.push((e + 256).toString(16).slice(1));
function ee(e, t = 0) {
  return (R[e[t + 0]] + R[e[t + 1]] + R[e[t + 2]] + R[e[t + 3]] + "-" + R[e[t + 4]] + R[e[t + 5]] + "-" + R[e[t + 6]] + R[e[t + 7]] + "-" + R[e[t + 8]] + R[e[t + 9]] + "-" + R[e[t + 10]] + R[e[t + 11]] + R[e[t + 12]] + R[e[t + 13]] + R[e[t + 14]] + R[e[t + 15]]).toLowerCase();
}
let Y;
const te = new Uint8Array(16);
function ne() {
  if (!Y) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Y = crypto.getRandomValues.bind(crypto);
  }
  return Y(te);
}
const oe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), q = { randomUUID: oe };
function G(e, t, n) {
  var s;
  if (q.randomUUID && !e)
    return q.randomUUID();
  e = e || {};
  const o = e.random ?? ((s = e.rng) == null ? void 0 : s.call(e)) ?? ne();
  if (o.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, ee(o);
}
const Be = (e) => {
  const { creator: t, updatedBy: n } = e.target, o = e.bodies.reduce((s, p) => [...s, p.creator, p.updatedBy].filter(Boolean), []);
  return [
    t,
    n,
    ...o
  ].filter((s) => s);
}, j = (e) => {
  const t = (n) => {
    const o = { ...n };
    return n.created && typeof n.created == "string" && (o.created = new Date(n.created)), n.updated && typeof n.updated == "string" && (o.updated = new Date(n.updated)), o;
  };
  return {
    ...e,
    bodies: (e.bodies || []).map(t),
    target: t(e.target)
  };
}, Re = (e, t, n, o) => ({
  id: G(),
  annotation: typeof e == "string" ? e : e.id,
  created: n || /* @__PURE__ */ new Date(),
  creator: o,
  ...t
}), se = (e, t) => {
  const n = new Set(e.bodies.map((o) => o.id));
  return t.bodies.filter((o) => !n.has(o.id));
}, ie = (e, t) => {
  const n = new Set(t.bodies.map((o) => o.id));
  return e.bodies.filter((o) => !n.has(o.id));
}, de = (e, t) => t.bodies.map((n) => {
  const o = e.bodies.find((s) => s.id === n.id);
  return { newBody: n, oldBody: o && !N(o, n) ? o : void 0 };
}).filter(({ oldBody: n }) => n).map(({ oldBody: n, newBody: o }) => ({ oldBody: n, newBody: o })), re = (e, t) => !N(e.target, t.target), J = (e, t) => {
  const n = se(e, t), o = ie(e, t), s = de(e, t);
  return {
    oldValue: e,
    newValue: t,
    bodiesCreated: n.length > 0 ? n : void 0,
    bodiesDeleted: o.length > 0 ? o : void 0,
    bodiesUpdated: s.length > 0 ? s : void 0,
    targetUpdated: re(e, t) ? { oldTarget: e.target, newTarget: t.target } : void 0
  };
};
var ce = /* @__PURE__ */ ((e) => (e.BODY_ONLY = "BODY_ONLY", e.TARGET_ONLY = "TARGET_ONLY", e))(ce || {}), O = /* @__PURE__ */ ((e) => (e.LOCAL = "LOCAL", e.REMOTE = "REMOTE", e.SILENT = "SILENT", e))(O || {});
const ae = (e, t) => {
  var p, A;
  const { changes: n, origin: o } = t;
  if (!(e.options.origin ? e.options.origin === o : o !== "SILENT"))
    return !1;
  if (e.options.ignore) {
    const { ignore: b } = e.options, E = (S) => S && S.length > 0;
    if (!(E(n.created) || E(n.deleted))) {
      const S = (p = n.updated) == null ? void 0 : p.some((w) => E(w.bodiesCreated) || E(w.bodiesDeleted) || E(w.bodiesUpdated)), l = (A = n.updated) == null ? void 0 : A.some((w) => w.targetUpdated);
      if (b === "BODY_ONLY" && S && !l || b === "TARGET_ONLY" && l && !S)
        return !1;
    }
  }
  if (e.options.annotations) {
    const b = /* @__PURE__ */ new Set([
      ...(n.created || []).map((h) => h.id),
      ...(n.deleted || []).map((h) => h.id),
      ...(n.updated || []).map(({ oldValue: h }) => h.id)
    ]);
    return !!(Array.isArray(e.options.annotations) ? e.options.annotations : [e.options.annotations]).find((h) => b.has(h));
  } else
    return !0;
}, le = (e, t) => {
  const n = new Set((e.created || []).map((l) => l.id)), o = new Set((e.updated || []).map(({ newValue: l }) => l.id)), s = new Set((t.created || []).map((l) => l.id)), p = new Set((t.deleted || []).map((l) => l.id)), A = new Set((t.updated || []).map(({ oldValue: l }) => l.id)), b = new Set((t.updated || []).filter(({ oldValue: l }) => n.has(l.id) || o.has(l.id)).map(({ oldValue: l }) => l.id)), E = [
    ...(e.created || []).filter((l) => !p.has(l.id)).map((l) => A.has(l.id) ? t.updated.find(({ oldValue: w }) => w.id === l.id).newValue : l),
    ...t.created || []
  ], h = [
    ...(e.deleted || []).filter((l) => !s.has(l.id)),
    ...(t.deleted || []).filter((l) => !n.has(l.id))
  ], S = [
    ...(e.updated || []).filter(({ newValue: l }) => !p.has(l.id)).map((l) => {
      const { oldValue: w, newValue: D } = l;
      if (A.has(D.id)) {
        const m = t.updated.find((C) => C.oldValue.id === D.id).newValue;
        return J(w, m);
      } else
        return l;
    }),
    ...(t.updated || []).filter(({ oldValue: l }) => !b.has(l.id))
  ];
  return { created: E, deleted: h, updated: S };
}, $ = (e) => {
  const t = e.id === void 0 ? G() : e.id;
  return {
    ...e,
    id: t,
    bodies: e.bodies === void 0 ? [] : e.bodies.map((n) => ({
      ...n,
      annotation: t
    })),
    target: {
      ...e.target,
      annotation: t
    }
  };
}, ue = (e) => e.id !== void 0, xe = () => {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = [], o = (i, r = {}) => {
    n.push({ onChange: i, options: r });
  }, s = (i) => {
    const r = n.findIndex((u) => u.onChange == i);
    r > -1 && n.splice(r, 1);
  }, p = (i, r) => {
    const u = {
      origin: i,
      changes: {
        created: r.created || [],
        updated: r.updated || [],
        deleted: r.deleted || []
      },
      state: [...e.values()]
    };
    n.forEach((f) => {
      ae(f, u) && f.onChange(u);
    });
  }, A = (i, r = O.LOCAL) => {
    if (i.id && e.get(i.id))
      throw Error(`Cannot add annotation ${i.id} - exists already`);
    {
      const f = $(i);
      e.set(f.id, f), f.bodies.forEach((L) => t.set(L.id, f.id)), p(r, { created: [f] });
    }
  }, b = (i, r) => {
    const u = $(typeof i == "string" ? r : i), f = typeof i == "string" ? i : i.id, L = f && e.get(f);
    if (L) {
      const y = J(L, u);
      return f === u.id ? e.set(f, u) : (e.delete(f), e.set(u.id, u)), L.bodies.forEach((B) => t.delete(B.id)), u.bodies.forEach((B) => t.set(B.id, u.id)), y;
    } else
      console.warn(`Cannot update annotation ${f} - does not exist`);
  }, E = (i, r = O.LOCAL, u = O.LOCAL) => {
    const f = ue(r) ? u : r, L = b(i, r);
    L && p(f, { updated: [L] });
  }, h = (i, r = O.LOCAL) => {
    !!e.get(i.id) ? E(i, r) : A(i, r);
  }, S = (i, r = O.LOCAL) => {
    const u = i.reduce((f, L) => {
      const y = b(L);
      return y ? [...f, y] : f;
    }, []);
    u.length > 0 && p(r, { updated: u });
  }, l = (i, r = O.LOCAL) => {
    const u = i.map($), { toAdd: f, toUpdate: L } = u.reduce((B, I) => e.get(I.id) ? { ...B, toUpdate: [...B.toUpdate, I] } : { ...B, toAdd: [...B.toAdd, I] }, { toAdd: [], toUpdate: [] }), y = L.map((B) => b(B, r)).filter(Boolean);
    f.forEach((B) => {
      e.set(B.id, B), B.bodies.forEach((I) => t.set(I.id, B.id));
    }), p(r, { created: f, updated: y });
  }, w = (i, r = O.LOCAL) => {
    const u = e.get(i.annotation);
    if (u) {
      const f = {
        ...u,
        bodies: [...u.bodies, i]
      };
      e.set(u.id, f), t.set(i.id, f.id), p(r, { updated: [{
        oldValue: u,
        newValue: f,
        bodiesCreated: [i]
      }] });
    } else
      console.warn(`Attempt to add body to missing annotation: ${i.annotation}`);
  }, D = () => [...e.values()], m = (i = O.LOCAL) => {
    const r = [...e.values()];
    e.clear(), t.clear(), p(i, { deleted: r });
  }, C = (i, r = !0, u = O.LOCAL) => {
    const f = i.map($);
    if (r) {
      const L = [...e.values()];
      e.clear(), t.clear(), f.forEach((y) => {
        e.set(y.id, y), y.bodies.forEach((B) => t.set(B.id, y.id));
      }), p(u, { created: f, deleted: L });
    } else {
      const L = i.reduce((y, B) => {
        const I = B.id && e.get(B.id);
        return I ? [...y, I] : y;
      }, []);
      if (L.length > 0)
        throw Error(`Bulk insert would overwrite the following annotations: ${L.map((y) => y.id).join(", ")}`);
      f.forEach((y) => {
        e.set(y.id, y), y.bodies.forEach((B) => t.set(B.id, y.id));
      }), p(u, { created: f });
    }
  }, T = (i) => {
    const r = typeof i == "string" ? i : i.id, u = e.get(r);
    if (u)
      return e.delete(r), u.bodies.forEach((f) => t.delete(f.id)), u;
    console.warn(`Attempt to delete missing annotation: ${r}`);
  }, a = (i, r = O.LOCAL) => {
    const u = T(i);
    u && p(r, { deleted: [u] });
  }, d = (i, r = O.LOCAL) => {
    const u = i.reduce((f, L) => {
      const y = T(L);
      return y ? [...f, y] : f;
    }, []);
    u.length > 0 && p(r, { deleted: u });
  }, g = (i) => {
    const r = e.get(i.annotation);
    if (r) {
      const u = r.bodies.find((f) => f.id === i.id);
      if (u) {
        t.delete(u.id);
        const f = {
          ...r,
          bodies: r.bodies.filter((y) => y.id !== i.id)
        };
        return e.set(r.id, f), {
          oldValue: r,
          newValue: f,
          bodiesDeleted: [u]
        };
      } else
        console.warn(`Attempt to delete missing body ${i.id} from annotation ${i.annotation}`);
    } else
      console.warn(`Attempt to delete body from missing annotation ${i.annotation}`);
  }, v = (i, r = O.LOCAL) => {
    const u = g(i);
    u && p(r, { updated: [u] });
  }, c = (i, r = O.LOCAL) => {
    const u = i.map((f) => g(f)).filter(Boolean);
    u.length > 0 && p(r, { updated: u });
  }, U = (i) => {
    const r = e.get(i);
    return r ? { ...r } : void 0;
  }, x = (i) => {
    const r = t.get(i);
    if (r) {
      const f = U(r).bodies.find((L) => L.id === i);
      if (f)
        return f;
      console.error(`Store integrity error: body ${i} in index, but not in annotation`);
    } else
      console.warn(`Attempt to retrieve missing body: ${i}`);
  }, k = (i, r) => {
    if (i.annotation !== r.annotation)
      throw "Annotation integrity violation: annotation ID must be the same when updating bodies";
    const u = e.get(i.annotation);
    if (u) {
      const f = u.bodies.find((y) => y.id === i.id), L = {
        ...u,
        bodies: u.bodies.map((y) => y.id === f.id ? r : y)
      };
      return e.set(u.id, L), f.id !== r.id && (t.delete(f.id), t.set(r.id, L.id)), {
        oldValue: u,
        newValue: L,
        bodiesUpdated: [{ oldBody: f, newBody: r }]
      };
    } else
      console.warn(`Attempt to add body to missing annotation ${i.annotation}`);
  }, X = (i, r, u = O.LOCAL) => {
    const f = k(i, r);
    f && p(u, { updated: [f] });
  }, Z = (i, r = O.LOCAL) => {
    const u = i.map((f) => k({ id: f.id, annotation: f.annotation }, f)).filter(Boolean);
    p(r, { updated: u });
  }, H = (i) => {
    const r = e.get(i.annotation);
    if (r) {
      const u = {
        ...r,
        target: {
          ...r.target,
          ...i
        }
      };
      return e.set(r.id, u), {
        oldValue: r,
        newValue: u,
        targetUpdated: {
          oldTarget: r.target,
          newTarget: i
        }
      };
    } else
      console.warn(`Attempt to update target on missing annotation: ${i.annotation}`);
  };
  return {
    addAnnotation: A,
    addBody: w,
    all: D,
    bulkAddAnnotations: C,
    bulkDeleteAnnotations: d,
    bulkDeleteBodies: c,
    bulkUpdateAnnotations: S,
    bulkUpdateBodies: Z,
    bulkUpdateTargets: (i, r = O.LOCAL) => {
      const u = i.map((f) => H(f)).filter(Boolean);
      u.length > 0 && p(r, { updated: u });
    },
    bulkUpsertAnnotations: l,
    clear: m,
    deleteAnnotation: a,
    deleteBody: v,
    getAnnotation: U,
    getBody: x,
    observe: o,
    unobserve: s,
    updateAnnotation: E,
    updateBody: X,
    updateTarget: (i, r = O.LOCAL) => {
      const u = H(i);
      u && p(r, { updated: [u] });
    },
    upsertAnnotation: h
  };
}, ke = (e) => ({
  ...e,
  subscribe: (n) => {
    const o = (s) => n(s.state);
    return e.observe(o), n(e.all()), () => e.unobserve(o);
  }
});
let Q = () => ({
  emit(e, ...t) {
    for (let n = this.events[e] || [], o = 0, s = n.length; o < s; o++)
      n[o](...t);
  },
  events: {},
  on(e, t) {
    var n;
    return ((n = this.events)[e] || (n[e] = [])).push(t), () => {
      var o;
      this.events[e] = (o = this.events[e]) == null ? void 0 : o.filter((s) => t !== s);
    };
  }
});
const fe = 250, Ie = (e, t) => {
  const n = Q(), o = (t == null ? void 0 : t.changes) || [];
  let s = t ? t.pointer : -1, p = !1, A = 0;
  const b = (c) => {
    if (!p) {
      const { changes: U } = c, x = performance.now();
      if (x - A > fe)
        o.splice(s + 1), o.push(U), s = o.length - 1;
      else {
        const k = o.length - 1;
        o[k] = le(o[k], U);
      }
      A = x;
    }
    p = !1;
  };
  e.observe(b, { origin: O.LOCAL });
  const E = (c) => c && c.length > 0 && e.bulkDeleteAnnotations(c), h = (c) => c && c.length > 0 && e.bulkAddAnnotations(c, !1), S = (c) => c && c.length > 0 && e.bulkUpdateAnnotations(c.map(({ oldValue: U }) => U)), l = (c) => c && c.length > 0 && e.bulkUpdateAnnotations(c.map(({ newValue: U }) => U)), w = (c) => c && c.length > 0 && e.bulkAddAnnotations(c, !1), D = (c) => c && c.length > 0 && e.bulkDeleteAnnotations(c);
  return {
    canRedo: () => o.length - 1 > s,
    canUndo: () => s > -1,
    destroy: () => e.unobserve(b),
    getHistory: () => ({ changes: [...o], pointer: s }),
    on: (c, U) => n.on(c, U),
    redo: () => {
      if (o.length - 1 > s) {
        p = !0;
        const { created: c, updated: U, deleted: x } = o[s + 1];
        h(c), l(U), D(x), n.emit("redo", o[s + 1]), s += 1;
      }
    },
    undo: () => {
      if (s > -1) {
        p = !0;
        const { created: c, updated: U, deleted: x } = o[s];
        E(c), S(U), w(x), n.emit("undo", o[s]), s -= 1;
      }
    }
  };
}, Ne = () => {
  const { subscribe: e, set: t } = P([]);
  return {
    subscribe: e,
    set: t
  };
}, ze = (e, t, n, o) => {
  const { hover: s, selection: p, store: A, viewport: b } = e, E = /* @__PURE__ */ new Map();
  let h = [], S, l;
  const w = (a, d) => {
    E.has(a) ? E.get(a).push(d) : E.set(a, [d]);
  }, D = (a, d) => {
    const g = E.get(a);
    if (g) {
      const v = g.indexOf(d);
      v !== -1 && g.splice(v, 1);
    }
  }, m = (a, d, g) => {
    E.has(a) && setTimeout(() => {
      E.get(a).forEach((v) => {
        if (n) {
          const c = Array.isArray(d) ? d.map((x) => n.serialize(x)) : n.serialize(d), U = g ? g instanceof PointerEvent ? g : n.serialize(g) : void 0;
          v(c, U);
        } else
          v(d, g);
      });
    }, 1);
  }, C = () => {
    const { selected: a } = p, d = (a || []).map(({ id: g }) => A.getAnnotation(g));
    d.forEach((g) => {
      const v = h.find((c) => c.id === g.id);
      (!v || !N(v, g)) && m("updateAnnotation", g, v);
    }), h = h.map((g) => {
      const v = d.find(({ id: c }) => c === g.id);
      return v || g;
    });
  };
  p.subscribe(({ selected: a }) => {
    if (!(h.length === 0 && a.length === 0)) {
      if (h.length === 0 && a.length > 0)
        h = a.map(({ id: d }) => A.getAnnotation(d));
      else if (h.length > 0 && a.length === 0)
        h.forEach((d) => {
          const g = A.getAnnotation(d.id);
          g && !N(g, d) && m("updateAnnotation", g, d);
        }), h = [];
      else {
        const d = new Set(h.map((c) => c.id)), g = new Set(a.map(({ id: c }) => c));
        h.filter((c) => !g.has(c.id)).forEach((c) => {
          const U = A.getAnnotation(c.id);
          U && !N(U, c) && m("updateAnnotation", U, c);
        }), h = [
          // Remove annotations that were deselected
          ...h.filter((c) => g.has(c.id)),
          // Add editable annotations that were selected
          ...a.filter(({ id: c }) => !d.has(c)).map(({ id: c }) => A.getAnnotation(c))
        ];
      }
      m("selectionChanged", h);
    }
  }), s.subscribe((a) => {
    !S && a ? m("mouseEnterAnnotation", A.getAnnotation(a)) : S && !a ? m("mouseLeaveAnnotation", A.getAnnotation(S)) : S && a && (m("mouseLeaveAnnotation", A.getAnnotation(S)), m("mouseEnterAnnotation", A.getAnnotation(a))), S = a;
  }), b == null || b.subscribe((a) => m("viewportIntersect", a.map((d) => A.getAnnotation(d)))), A.observe((a) => {
    o && (l && clearTimeout(l), l = setTimeout(C, 1e3));
    const { created: d, deleted: g } = a.changes;
    (d || []).forEach((c) => m("createAnnotation", c)), (g || []).forEach((c) => m("deleteAnnotation", c)), (a.changes.updated || []).filter((c) => [
      ...c.bodiesCreated || [],
      ...c.bodiesDeleted || [],
      ...c.bodiesUpdated || []
    ].length > 0).forEach(({ oldValue: c, newValue: U }) => {
      const x = h.find((k) => k.id === c.id) || c;
      h = h.map((k) => k.id === c.id ? U : k), m("updateAnnotation", U, x);
    });
  }, { origin: O.LOCAL }), A.observe((a) => {
    if (h) {
      const d = new Set(h.map((v) => v.id)), g = (a.changes.updated || []).filter(({ newValue: v }) => d.has(v.id)).map(({ newValue: v }) => v);
      g.length > 0 && (h = h.map((v) => {
        const c = g.find((U) => U.id === v.id);
        return c || v;
      }));
    }
  }, { origin: O.REMOTE });
  const T = (a) => (d) => {
    const { updated: g } = d;
    a ? (g || []).forEach((v) => m("updateAnnotation", v.oldValue, v.newValue)) : (g || []).forEach((v) => m("updateAnnotation", v.newValue, v.oldValue));
  };
  return t.on("undo", T(!0)), t.on("redo", T(!1)), { on: w, off: D, emit: m };
}, $e = (e) => (t) => t.map((n) => e.serialize(n)), pe = (e) => (t) => t.reduce((n, o) => {
  const { parsed: s, error: p } = e.parse(o);
  return p ? {
    parsed: n.parsed,
    failed: [...n.failed, o]
  } : s ? {
    parsed: [...n.parsed, s],
    failed: n.failed
  } : {
    ...n
  };
}, { parsed: [], failed: [] }), Ve = (e, t, n) => {
  const { store: o, selection: s } = e, p = (a) => {
    if (n) {
      const { parsed: d, error: g } = n.parse(a);
      d ? o.addAnnotation(d, O.REMOTE) : console.error(g);
    } else
      o.addAnnotation(j(a), O.REMOTE);
  }, A = () => s.clear(), b = () => o.clear(), E = (a) => {
    const d = o.getAnnotation(a);
    return n && d ? n.serialize(d) : d;
  }, h = () => n ? o.all().map(n.serialize) : o.all(), S = () => {
    var g;
    const d = (((g = s.selected) == null ? void 0 : g.map((v) => v.id)) || []).map((v) => o.getAnnotation(v)).filter(Boolean);
    return n ? d.map(n.serialize) : d;
  }, l = (a, d = !0) => fetch(a).then((g) => g.json()).then((g) => (D(g, d), g)), w = (a) => {
    if (typeof a == "string") {
      const d = o.getAnnotation(a);
      if (o.deleteAnnotation(a), d)
        return n ? n.serialize(d) : d;
    } else {
      const d = n ? n.parse(a).parsed : a;
      if (d)
        return o.deleteAnnotation(d), a;
    }
  }, D = (a, d = !0) => {
    if (n) {
      const g = n.parseAll || pe(n), { parsed: v, failed: c } = g(a);
      c.length > 0 && console.warn(`Discarded ${c.length} invalid annotations`, c), o.bulkAddAnnotations(v, d, O.REMOTE);
    } else
      o.bulkAddAnnotations(a.map(j), d, O.REMOTE);
  }, m = (a, d) => {
    a ? s.setSelected(a, d) : s.clear();
  }, C = (a) => {
    s.clear(), s.setUserSelectAction(a);
  }, T = (a) => {
    if (n) {
      const d = n.parse(a).parsed, g = n.serialize(o.getAnnotation(d.id));
      return o.updateAnnotation(d), g;
    } else {
      const d = o.getAnnotation(a.id);
      return o.updateAnnotation(j(a)), d;
    }
  };
  return {
    addAnnotation: p,
    cancelSelected: A,
    canRedo: t.canRedo,
    canUndo: t.canUndo,
    clearAnnotations: b,
    getAnnotationById: E,
    getAnnotations: h,
    getHistory: t.getHistory,
    getSelected: S,
    loadAnnotations: l,
    redo: t.redo,
    removeAnnotation: w,
    setAnnotations: D,
    setSelected: m,
    setUserSelectAction: C,
    undo: t.undo,
    updateAnnotation: T
  };
}, _e = (e, t, n) => typeof t == "function" ? t(e, n) : t, Ye = (e, t) => typeof e != "function" && typeof t != "function" ? {
  ...e || {},
  ...t || {}
} : (n, o) => {
  const s = typeof e == "function" ? e(n, o) : e, p = typeof t == "function" ? t(n, o) : t;
  return {
    ...s || {},
    ...p || {}
  };
}, ge = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let he = (e) => crypto.getRandomValues(new Uint8Array(e)), me = (e, t, n) => {
  let o = (2 << Math.log2(e.length - 1)) - 1, s = -~(1.6 * o * t / e.length);
  return (p = t) => {
    let A = "";
    for (; ; ) {
      let b = n(s), E = s | 0;
      for (; E--; )
        if (A += e[b[E] & o] || "", A.length >= p) return A;
    }
  };
}, Ae = (e, t = 21) => me(e, t | 0, he), be = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += ge[n[e] & 63];
  return t;
};
const je = () => ({ isGuest: !0, id: Ae("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_", 20)() }), ve = (e) => {
  const t = JSON.stringify(e);
  let n = 0;
  for (let o = 0, s = t.length; o < s; o++) {
    let p = t.charCodeAt(o);
    n = (n << 5) - n + p, n |= 0;
  }
  return `${n}`;
}, Ee = (e) => e ? typeof e == "object" ? { ...e } : e : void 0, Pe = (e, t) => (Array.isArray(e) ? e : [e]).map((n) => {
  const { id: o, type: s, purpose: p, value: A, created: b, modified: E, creator: h, ...S } = n;
  return {
    id: o || `temp-${ve(n)}`,
    annotation: t,
    type: s,
    purpose: p,
    value: A,
    creator: Ee(h),
    created: b ? new Date(b) : void 0,
    updated: E ? new Date(E) : void 0,
    ...S
  };
}), He = (e) => e.map((t) => {
  var b;
  const { annotation: n, created: o, updated: s, ...p } = t, A = {
    ...p,
    created: o == null ? void 0 : o.toISOString(),
    modified: s == null ? void 0 : s.toISOString()
  };
  return (b = A.id) != null && b.startsWith("temp-") && delete A.id, A;
}), we = [
  "#ff7c00",
  // orange
  "#1ac938",
  // green
  "#e8000b",
  // red
  "#8b2be2",
  // purple
  "#9f4800",
  // brown
  "#f14cc1",
  // pink
  "#ffc400",
  // khaki
  "#00d7ff",
  // cyan
  "#023eff"
  // blue
], Ce = () => {
  const e = [...we];
  return { assignRandomColor: () => {
    const o = Math.floor(Math.random() * e.length), s = e[o];
    return e.splice(o, 1), s;
  }, releaseColor: (o) => e.push(o) };
}, ye = () => {
  const e = Ce();
  return { addUser: (o, s) => {
    const p = e.assignRandomColor();
    return {
      label: s.name || s.id,
      avatar: s.avatar,
      color: p
    };
  }, removeUser: (o) => e.releaseColor(o.appearance.color) };
}, Le = (e, t) => e.every((n) => e.includes(n)) && t.every((n) => e.includes(n)), Me = be(), We = (e = ye()) => {
  const t = Q(), n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = (l, w) => {
    if (n.has(l)) {
      console.warn("Attempt to add user that is already present", l, w);
      return;
    }
    const D = e.addUser(l, w);
    n.set(l, {
      ...w,
      presenceKey: l,
      appearance: D
    });
  }, p = (l) => {
    const w = n.get(l);
    if (!w) {
      console.warn("Attempt to remove user that is not present", l);
      return;
    }
    e.removeUser(w), n.delete(l);
  }, A = (l) => {
    const w = new Set(l.map((C) => C.presenceKey)), D = l.filter(({ presenceKey: C }) => !n.has(C)), m = Array.from(n.values()).filter((C) => !w.has(C.presenceKey));
    D.forEach(({ presenceKey: C, user: T }) => s(C, T)), m.forEach((C) => {
      const { presenceKey: T } = C;
      o.has(T) && t.emit("selectionChange", C, null), p(T);
    }), (D.length > 0 || m.length > 0) && t.emit("presence", h());
  }, b = (l, w) => {
    const D = n.get(l);
    if (!D) {
      console.warn("Activity notification from user that is not present");
      return;
    }
    const m = o.get(l);
    (!m || !Le(m, w)) && (o.set(l, w), t.emit("selectionChange", D, w));
  }, E = (l, w) => {
    const D = n.get(l);
    if (!D) {
      console.warn("Selection change for user that is not present", l);
      return;
    }
    w ? o.set(l, w) : o.delete(l), t.emit("selectionChange", D, w);
  }, h = () => [...Array.from(n.values())];
  return {
    getPresentUsers: h,
    notifyActivity: b,
    on: (l, w) => t.on(l, w),
    syncUsers: A,
    updateSelection: E
  };
};
export {
  ce as Ignore,
  O as Origin,
  Me as PRESENCE_KEY,
  K as UserSelectAction,
  Ye as chainStyles,
  _e as computeStyle,
  je as createAnonymousGuest,
  Ve as createBaseAnnotator,
  Re as createBody,
  ye as createDefaultAppearanceProvider,
  Oe as createHoverState,
  ze as createLifecycleObserver,
  We as createPresenceState,
  De as createSelectionState,
  xe as createStore,
  Ie as createUndoStack,
  Ne as createViewportState,
  Ce as defaultColorProvider,
  J as diffAnnotations,
  Be as getContributors,
  le as mergeChanges,
  W as onUserSelect,
  pe as parseAll,
  Pe as parseW3CBodies,
  Ee as parseW3CUser,
  j as reviveDates,
  $e as serializeAll,
  He as serializeW3CBodies,
  ae as shouldNotify,
  ke as toSvelteStore
};
//# sourceMappingURL=annotorious-core.es.js.map
